import type { ProjectDashboardProject, ProjectDashboardRevision } from '../../projectDashboardTypes';

type RevisionStatus = 'loading' | 'analyzingDependencies' | 'analyzed' | 'failing' | 'unanalyzed';

/**
 * Get revision status based on the revision and project data.
 */
function getRevisionStatus(revision: ProjectDashboardRevision, project: ProjectDashboardProject): RevisionStatus {
  if (project.status.loading || !revision.data || revision.status.loading) {
    return 'loading';
  }
  // The revision needs to be "resolved" and in steady state
  const isResolvedAndAnalyzed = revision.data.resolved && project.data.latest && revision.data.isSteady;
  const isResolvedAndBuilding = revision.data.resolved && !revision.data.isSteady;
  if (isResolvedAndBuilding) {
    return 'analyzingDependencies';
  }
  if (isResolvedAndAnalyzed) {
    return (revision.data?.unresolved_issue_count || 0) <= 0 ? 'analyzed' : 'failing';
  }
  return 'unanalyzed';
}

export default getRevisionStatus;
